import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { Box, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { isDisabledAllFieldCsv } from '../handler/KnowledgeUploadCsvHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function DropDownOverWriteAttachment({
    selectedAttachFile,
    setSelectedAttachFile,
    handleStatus
}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    return (
        <div className="options-import-csv">
            <label className="label-upload-csv">
                {trI18n('LABEL-SETTING-OVERWRITE-ATTACH-FILE')}
            </label>
            <Select
                fullWidth
                className="form-control form-control--wrap"
                select
                disabled={isDisabledAllFieldCsv(handleStatus)}
                value={selectedAttachFile}
                variant="outlined"
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    },
                    getContentAnchorEl: null
                }}
                onChange={e => setSelectedAttachFile(e.target.value)}
            >
                <MenuItem value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.UPDATE}>
                    <OverFlowTooltipWithTabsMui
                        value={trI18n('LABEL-UPDATE-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
                <MenuItem value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.ADD}>
                    <OverFlowTooltipWithTabsMui
                        value={trI18n('LABEL-ADD-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
                <MenuItem
                    value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.NO_CHANGE}
                >
                    <OverFlowTooltipWithTabsMui
                        value={trI18n('LABEL-NO-CHANGE-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
            </Select>
        </div>
    );
}
